import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Anonymous browser session id (persist for visitor-level analytics)
function getSessionId() {
  if (typeof window === "undefined") return null;
  let sid = localStorage.getItem("dp_pixel_sid");
  if (!sid) {
    sid = `sid_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("dp_pixel_sid", sid);
  }
  return sid;
}

export function track(eventName, meta = {}) {
  if (typeof window === "undefined") return;
  try {
    const intentId = localStorage.getItem("dp_intent_id") || undefined;
    axios.post(
      `${API}/pixel/track`,
      {
        name: eventName,
        path: window.location.pathname + window.location.hash,
        session_id: getSessionId(),
        intent_id: intentId,
        meta,
      },
      { timeout: 4000 }
    ).catch(() => {}); // silent
  } catch {
    /* no-op */
  }
}

// Convenience for click handlers
export function withTrack(eventName, handler, meta) {
  return (...args) => {
    track(eventName, meta);
    return handler?.(...args);
  };
}
